@import "tailwindcss";
@import "../../Shared/assets/fonts.css";
@config "../tailwind.config.js";
@source "../../Shared/**/*.{js,jsx,ts,tsx}";

@keyframes kenBurns {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.25);
  }

  100% {
    transform: scale(1);
  }
}

.styled-image {
  transition: opacity 0.5s ease-in-out;
  /* Fade in (once loaded) */
}

.bg-container {
  background-color: #0b0c23;

  .styled-image {
    background-size: cover;
    object-fit: cover;
    transform: scale(1);
    pointer-events: none;
    animation: var(--custom-login-bg-animation, kenBurns 80s infinite);
    /* Easy breathing animation */
  }
}

.logo-container {
  .image-container {
    width: 180px;
    height: 50px;

    .styled-image {
      object-fit: contain;
    }
  }
}

#login,
#register {
  height: 100%;
  inset: 0;

  form {
    box-shadow: 0 4px 84px rgba(0, 4, 81, 0.07);
    background: var(--color-grey-100);

    .ms-btn {
      background: var(--color-white-100);
      color: var(--color-blue-400);
      box-shadow: 0 6px 20px rgba(0, 4, 81, 0.06);
    }

    .login-btn {
      background: var(--custom-login-color, --color-blue-600);
    }
  }
}
